import React, { HTMLAttributes } from 'react';
import { Link } from 'react-router-dom';

import { Breadcrumb } from 'src/components/Breadcrumbs/breadcrumb.utils';

import classes from './Breadcrumbs.scss';
import { BreadcrumbSchema } from './BreadcrumbsStructuredData';

type BreadcrumbsProps = {
    breadcrumbs: Breadcrumb[];
    current: string;
} & HTMLAttributes<any>;

export function Breadcrumbs(props: BreadcrumbsProps) {
    const { current, breadcrumbs, children, ...rest } = props;
    return (
        <div className={classes.root} {...rest}>
            <div className="scroller">
                <ul className="breadcrumbs">
                    <li>
                        <Link to="/" title="Go to Home Page">
                            Home
                        </Link>
                    </li>
                    {props.breadcrumbs.map((breadcrumb) => {
                        const url_key = breadcrumb.url_key.replace(/^\//, '');
                        const url = breadcrumb.url || `/` + breadcrumb.url_path.concat(url_key).join('/');

                        return (
                            <li key={breadcrumb.id}>
                                <Link to={url} title="">
                                    {breadcrumb.name}
                                </Link>
                            </li>
                        );
                    })}
                    <li>{props.current}</li>
                </ul>
            </div>
            <BreadcrumbSchema breadcrumbs={props.breadcrumbs} current={props.current} />
        </div>
    );
}
